<script>
import QuestionTooltip from "@/components/app/policyCancel/components/QuestionTooltip.vue";
import FileInput from "@/components/app/policyCancel/components/FileInput.vue";

export default {
    name: "PzuPolicyCancel",
    components: {FileInput, QuestionTooltip},
    model: {
        prop: 'dataForm',
        event: 'input',
    },
    props: {
        dataForm: {
            type: Object,
            default: function () {
                return {
                    file: null,
                }
            }
        },
        moduleId: {
            // type: Integer,
            default: function () {
                return '';
            }
        },
        companyName: {
            type: String,
            default: function () {
                return '';
            },
        },
    },
    data() {
        return {
            checked: false,
        }
    },
    watch: {
        dataForm: {
            handler: function (val) {
                this.$emit('is-fill-form', val.reason);
            },
            deep: true
        }
    },
}
</script>

<template>
    <div class="policy-cancel-custom">
<!--        <question-tooltip>-->
<!--            УВАГА! Заява має бути від імені клієнта,  з вірними датами та повністю заповнена, інакше страхові компанії можуть відмовити в ануляції договору.-->
<!--        </question-tooltip>-->
        <el-row>
            <el-col class="title mb-4">
                <label><b>Причина ануляції</b></label>
                <el-input placeholder="Причина ануляції"
                          v-model="dataForm.reason"></el-input>
            </el-col>
            <el-col class="mb-4">
                <label><b>Чи укладено новий поліс взамін цього в даній СК?</b></label>
                <el-input v-if="checked" placeholder="Наприклад, 200058325"
                          v-model="dataForm.numberPolicy"></el-input>
            </el-col>
            <el-col>
                <el-checkbox v-model="checked">Новий поліс взамін цього <br> не оформлювався</el-checkbox>
            </el-col>
        </el-row>
    </div>
</template>

<style scoped>
* >>> .el-checkbox__input {
    vertical-align: super;
}
</style>
